import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { ulmClasses } from '../../data/classes';
export function ClassesSection() {
  const featured = ulmClasses.find(item => item.featured) ?? ulmClasses[0];
  const others = ulmClasses.filter(item => item.id !== featured.id);
  return <section id="classes" className="bg-cloud py-20 lg:py-28" data-id="element-36" data-mp="iqcysigoemaa">
      <div className="mx-auto max-w-shell px-5 lg:px-8" data-id="element-37" data-mp="ios3gqmjezbd">
        <div className="max-w-2xl" data-id="element-38" data-mp="4q25z9vt2xmh">
          <h2 className="ffp-display text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-39" data-mp="4t6iqvnc71or">Les six classes d’ULM</h2>
          <p className="mt-4 text-[17px] leading-relaxed text-ink/65" data-id="element-40" data-mp="9ntz2786sps9">
            Chaque classe a son brevet, ses sensations et son budget. Le choix se fait presque toujours après
            un premier vol de découverte.
          </p>
        </div>

        <div className="mt-12 grid gap-5 lg:grid-cols-3" data-id="element-41" data-mp="1q5hs4g8keztp">
          <article className="group flex flex-col overflow-hidden rounded-xl bg-white lg:col-span-2 lg:flex-row" data-id="element-42" data-mp="1u61kl6i71f9i">
            <div className="relative lg:w-1/2" data-id="element-43" data-mp="398cqjmt36w1u">
              <img src={featured.image} alt={`ULM de classe ${featured.number} — ${featured.name}`} className="h-56 w-full object-cover lg:h-full" data-id="element-44" data-mp="3971nxqbdnucb" />
              <span className="ffp-display absolute left-4 top-4 rounded bg-flag px-2 py-1 text-[12px] font-bold uppercase tracking-wider text-white" data-id="element-45" data-mp="3j0qtujztcaq4">
                Classe {featured.number}
              </span>
            </div>
            <div className="flex flex-1 flex-col p-6 lg:p-8" data-id="element-46" data-mp="2lb5p88ibil9h">
              <h3 className="ffp-display text-2xl font-bold text-ink lg:text-3xl" data-id="element-47" data-mp="2lcqlq3o70e9z">{featured.name}</h3>
              <p className="mt-1 text-[14px] font-semibold text-azure" data-id="element-48" data-mp="3063gsz5n76pi">{featured.tagline}</p>
              <p className="mt-4 text-[15px] leading-relaxed text-ink/65" data-id="element-49" data-mp="2v7s8isuzx49e">{featured.description}</p>
              <a href="#former" className="ffp-focus mt-auto inline-flex items-center gap-1.5 pt-6 text-[14px] font-semibold text-navy" data-id="element-50" data-mp="fg4eb57d9pua">
                Se former au multiaxe
                <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-51" data-mp="ml5h975vxw67" />
              </a>
            </div>
          </article>

          {others.map(item => <article key={item.id} className="flex flex-col overflow-hidden rounded-xl bg-white" data-id="element-52" data-mp="rkrtpedw38dy">
              <img src={item.image} alt={`ULM de classe ${item.number} — ${item.name}`} className="h-44 w-full object-cover" data-id="element-53" data-mp="witf45ysfjsl" />
              <div className="flex flex-1 flex-col p-6" data-id="element-54" data-mp="3vfosqplhmhg">
                <span className="ffp-display text-[12px] font-bold uppercase tracking-wider text-ink/45" data-id="element-55" data-mp="8u0nglp77y3s">
                  Classe {item.number}
                </span>
                <h3 className="ffp-display mt-1.5 text-xl font-bold text-ink" data-id="element-56" data-mp="dmk45rj6n9ct">{item.name}</h3>
                <p className="mt-1 text-[13px] font-semibold text-azure" data-id="element-57" data-mp="3ca7jc61dgr20">{item.tagline}</p>
                <p className="mt-3 text-[14px] leading-relaxed text-ink/65" data-id="element-58" data-mp="3h7psnxjax8aj">{item.description}</p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}